import { Button, Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import CustomAlert from "../../components/CustomAlert";
import { ErrorIcon, SuccessIcon } from "../../components/CustomIcons";
import CustomLoading from "../../components/CustomLoading";
import { connection } from "../../config";
import { paths } from "../../config/router.config";
import wsclients from "../../services/wsclients";
import { lab4services } from "../../services/wsclients/lab4services";
import { getAddCardInfo, getData, getPackageInfo, getPaymentLinkInfo, getRegisterAttachments, logOut, setAddCardInfo, setPaymentInfo } from "../../utils/commons";

const useStyles = makeStyles((theme) => ({

}));

export default function PaymentResult(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const history = useHistory();

    const [showLoading, onShowLoading] = useState(false);
    const [result, setResult] = useState(null);
    const [message, setMessage] = useState(null);
    const [type, setType] = useState(null);
    const [error, setError] = useState({});
    const [tranInfo, setTranInfo] = useState(null);
    const [attachments, setAttachments] = useState([]);

    const onShowMessage = (message) => {
        onShowLoading(false)
        setMessage(message)
    }

    useEffect(() => {
        let attachments = getRegisterAttachments();
        if(attachments) setAttachments(attachments);
        let token = getData();
        if (token) onLoad();
        else{
            let paymentLinkInfo = getPaymentLinkInfo();
            if(paymentLinkInfo){
                onLoad();
            }
        }
    }, []);

    const onLoad = async () => {
        // debugger;
        onShowLoading(true);
        var url = new URL(window.location.href);
        let addCardInfo = getAddCardInfo();
        console.log("url===", url);
        var status = url.searchParams.get("transaction_status");
        var pay_request_id = url.searchParams.get("pay_request_id");
        var checksum = url.searchParams.get("checksum");
        var type = url.searchParams.get("type");
        setTranInfo({
            status: status,
            pay_request_id: pay_request_id,
            checksum: checksum,
            type: type,
        });
        let paymentLinkInfo = getPaymentLinkInfo();
        let packageInfo = getPackageInfo();
        //payment link
        if (paymentLinkInfo) {
            if(status == '1'){ // option OK
                setType('PAYMENT');
                if (type === '2') {
                    await onSubmitPayment(pay_request_id, checksum, 'paymentlink');
                }
                //payment link -> create vumatel order
                if(paymentLinkInfo && paymentLinkInfo.type == 'register')
                    await onLoadPaymentLinkInfo(paymentLinkInfo && paymentLinkInfo.contact_code ? paymentLinkInfo.contact_code : null);
                else await createVumatelOrderVumaCore(paymentLinkInfo);
                // else await createVumatelOrder(paymentLinkInfo);    
            } else {
                setResult({
                    status: "error",
                    desc: t('PAYMENT_FAILED')
                })
            }
        } 
        else {
            setType(type && (type === '0' || type === '2') ? 'PAYMENT' : 'ADD_CARD');
            if (status === '1') {
                if (type === '0') { //only create payment
                    await onCreatePayment(pay_request_id, checksum)
                }
                else if (type === '2') { //add card and submit payment the same time
                    await onSubmitPayment(pay_request_id, checksum);
                } else { //only add card
                    await onAddPaymentMethod(pay_request_id, checksum);
                }
            } else {
                onShowLoading(false);
                if (addCardInfo) {
                    setResult({
                        status: "failed",
                        desc: "Add payment method failed.",
                        is_add_card: true,
                    });
                    setAddCardInfo({});
                    // history.push(paths.setting);
                }
                else {
                    setPaymentInfo('FAILED');
                    setResult({
                        status: "failed",
                        desc: "PAYGATE-ERROR"
                    });
                    history.push(paths.register);
                }
            }
        }

        onShowLoading(false);
    }
    const onLoadPaymentInfo = async (pay_request_id, checksum) => {
        var paymentInfo = null;
        try {
            const result = await wsclients.paygateservices.getPaymentInfo({
                pay_request_id,
                checksum,
                url: connection.urlPaygate + "/paygate/payment_info",
                apikey: connection.apiKeyPaygate
            })
            console.log("result:", result);
            if (result.code == 'OK') {
                paymentInfo = result.data;
            }
        } catch (ex) {

        }
        return paymentInfo;
    }
    const onAddPaymentMethod = async (pay_request_id, checksum) => {
        const paymentInfo = await onLoadPaymentInfo(pay_request_id, checksum);
        if (paymentInfo != null) {
            let paygateIntegration = connection.paygateIntegration;
            let card_info = {}
            if (paymentInfo.vaultData1) {
                card_info.first6 = paymentInfo.vaultData1.substr(0, 6);
                card_info.last4 = paymentInfo.vaultData1.substr(paymentInfo.vaultData1.length - 4);
            }
            if (paymentInfo.vaultData2) {
                card_info.expiration_month = paymentInfo.vaultData2.substring(0, 2);
                card_info.expiration_year = paymentInfo.vaultData2.substring(2, paymentInfo.vaultData2.length)
            }

            let createCustomerResult = await wsclients.paymentgateway.addPaymentMethod({
                integration_id: paygateIntegration,
                payment_method_nonce_token: paymentInfo.vaultId,
                payment_method_type: "CARD",
                card_info: card_info,
                name: "Paygate"
            });
            console.log('createCustomerResult ===', createCustomerResult)
            if (createCustomerResult.code === 'OK') {
                setResult({
                    status: "success",
                    desc: "Add Card Successfully"
                })
            }
            else if (createCustomerResult.code === 'CUSTOMER_EMAIL_ALREADY_EXIST') {
                setResult({
                    status: "error",
                    desc: 'CRM-ERROR: Add card failed'
                })
            }
            else {
                setResult({
                    status: "error",
                    desc: 'CRM-ERROR: Add card failed'
                })
            }
            onShowLoading(false);
        } else {
            onShowLoading(false);
            setResult({
                status: "error",
                desc: "CRM-ERROR: " + t('EXCEPTION_PROCESS')
            })
        }
    }

    const onCreatePayment = async (pay_request_id) => {
        let result = await lab4services.createPayment({
            payment_request_id: pay_request_id,
            amount: '',
        });
        console.log('onCreatePayment ===', result)
        if (result.code === 'OK') {
            setResult({
                status: "success",
                desc: t('PAYMENT_SUCCESS')
            })
        }
        else {
            let mess = result.error && result.error.desc ? result.error.desc : t('EXCEPTION_PROCESS');
            setResult({
                status: "error",
                desc: 'CRM-ERROR: ' + t('PAYMENT_FAILED')
            })
            showMessage({ show: true, message: mess })
        }
        onShowLoading(false);
    }

    //add card and submit payment
    const onSubmitPayment = async (pay_request_id, checksum, type) => {
        let result = await lab4services.onSubmitPayment({
            payment_request_id: pay_request_id,
            checksum: checksum,
        });
        console.log('onSubmitPayment ===', result)
        if (result.code === 'OK') {
            setPaymentInfo('SUCCESS');
            if(type == 'paymentlink'){

            } else {
                let addCardInfo = getAddCardInfo();
                if (addCardInfo && addCardInfo.is_add) {
                    setAddCardInfo({
                        result: 'SUCCESS',
                    });
                    history.push(paths.setting);
                }
                else history.push(paths.register);
            }
        }
        else if (result.data && result.data.error && result.data.error.code && result.data.error.code === 'CREATE_PAYMENT_EXCEPTION') {
            setMessage({
                show: true,
                isConfirm: true,
                confirmAction: async () => await onSubmitPayment(pay_request_id, checksum),
            });
            setPaymentInfo('FAILED');
        }
        else {
            let mess = result.error && result.error.desc ? result.error.desc : t('EXCEPTION_PROCESS');
            setResult({
                status: "error",
            })
            showMessage({ status: true, message: mess })
            setPaymentInfo('FAILED');
        }
        onShowLoading(false);
    }

    const showMessage = async ({ status, message, confirmAction, isConfirm, action }) => {
        onShowLoading(false);
        setMessage({
            show: status,
            content: message ? message : null,
            confirmAction: confirmAction,
            isConfirm: isConfirm,
            action: action,
        });
    }

    const onLoadPaymentLinkInfo = async (contact_code) => {
        onShowLoading(true)
        try {
            let result = await lab4services.getPaymentInfoV2(contact_code);
            console.log("AAAA getPaymentInfoV2 result: ", result);
            if(result.code == 'OK'){
                if(result.data && result.data.crm_order_id){
                    await createVumatelOrderVumaCore(result.data);
                }
                else {
                    showMessage({ status: true, message: t('PAYMENT_LINK_NOT_FOUND'), action: () => {
                        logOut();
                    } });
                    return false;
                }
            }
            else {
                showMessage({ status:true, message: t('PAYMENT_LINK_NOT_FOUND'), action: () => {
                    logOut();
                } });
                return false;
            }
        } catch (ex) {
            console.log("AAAA onLoadPaymentInfo exception: ", ex);
        }
        onShowLoading(false);
    }

    const createVumatelOrderVumaCore = async (paymentInfo) => {
        onShowLoading(true)
        setMessage({})
        try {
            let result = await lab4services.makeOrderV2VumaCore(paymentInfo);
            console.log("AAAA makeOrderVumatel result: ", result);
            if(result.code == 'OK'){
                let message = t('CREATE_ORDRER_SUCCESS');
                if(result.data && result.data.access_token){
                    message = t('contact_existing_warning')
                    //upload files 
                    if (attachments && attachments.length > 0) {
                        let filesUploaded = await onUploadFile(attachments, result.data.access_token);
                        if (filesUploaded) onAddFilesContact(filesUploaded);
                    }
                }
                setResult({
                    status: 'success',
                    desc: t('CREATE_ORDER_SUCCESS'),
                    showBackLogin: true,
                })
                // showMessage({
                //     status: true,
                //     message: message, 
                //     onClose: () => {
                //         history.push(paths.login);
                //     }
                // });
            } else {
                let message = t('CREATE_ORDER_NOT_SUCCESS');
                if(result.code == 'CREATE_ACTIVITY_EXCEPTION') message = t('CREATE_ACTIVITY_EXCEPTION');
                if(result.code === 'VUMATEL_SERVER_ERROR') message = t('VUMATEL_SERVER_ERROR');
                let entityError = result.data.error && result.data.error.entity ? JSON.parse(result.data.error.entity) : null;
                if(entityError){
                    message = entityError && entityError.detail && typeof (entityError.detail) === 'string' && !entityError.detail.includes('Failed to create prepaid order:') ? entityError.detail : t('CREATE_ORDER_NOT_SUCCESS');
                }
                setResult({
                    status: 'failed',
                    desc: message,
                })
                showMessage({
                    status: true,
                    message: message,
                    isConfirm: true,
                    confirmAction: {
                        okTitle: t('btn_try'),
                        cancelTitle: t('btn_close'),
                        okAction: async () => {
                            await createVumatelOrderVumaCore(paymentInfo);
                        },
                        cancelAction: () => {
                            logOut();
                            history.push(paths.landing_page)
                        },
                    }
                });
            }
        } catch (ex) {
            console.log("AAAA createVumatelOrderVumaCore exception: ", ex);
        }
        onShowLoading(false)
    }
    
    const onUploadFile = async (filesContact, token) => {
        let _filesUploaded = [];
        try {
            console.log("filesContact:", filesContact)
            for (let i = 0; i < filesContact.length; i++) {
                const file = filesContact[i];
                const result = await wsclients.config.uploadFilesNew({ file: file, token: token });
                if (result.code == 'OK') {
                    if (result.data.id) _filesUploaded.push(result.data.id);
                } else if (result.data && result.data.error == 'COM.CRM.EXCEPTIONS.INVALIDFILETYPEEXCEPTION') {
                    showMessage({ status: true, message: t('INVALID_FILE_TYPE') })
                }
            }
        } catch (error) {
            console.log("onUploadFile exception:", error);
        }
        return _filesUploaded
    }

    const onAddFilesContact = async (filesUploaded) => {
        try {
            for (let i = 0; i < filesUploaded.length; i++) {
                await wsclients.lab4services.onUploadFile(filesUploaded[i]);
            }
            await setAttachments([]);
        } catch (error) {
            console.log("onAddSRAttachment exception:", error);
        }
    }

    const onBackLogin = () => {
        logOut();
        history.push(paths.login);
    }

    console.log("AAAA message: ", message);
    return (
        <Grid item xs={12}>
            <Grid xs={12} item container justifyContent='center' className={classes.content}>
                <Grid xs={12} item container justifyContent='center' marginTop={4}>
                    {result && result.status === 'success' && <SuccessIcon style={{ fontSize: 50 }} />}
                    {result && result.status === 'failed' && <ErrorIcon style={{ fontSize: 50 }} />}
                </Grid>
                <Grid xs={12} item container justifyContent='center' marginTop={4}>
                    {result && result.desc && <Typography variant='body2'>{result.desc}</Typography>}
                </Grid>
                <Grid xs={12} item container justifyContent='center' marginTop={4}>
                    {(result && !result.showBackLogin) && <Button variant='contained' onClick={() => history.push(result && result.is_add_card ? paths.setting : paths.home)}>{result && result.is_add_card ? t('Back to Profile') : t('btn_back_to_home')}</Button>}
                    {result && result.showBackLogin && <Button variant='contained' onClick={() => onBackLogin()}>{t('Back to Login')}</Button>}
                </Grid>
            </Grid>
            {message && message.show && <CustomAlert
                open={message.show}
                message={message.content}
                showButtonClose={true}
                isConfirm={message.isConfirm ? message.isConfirm : null}
                confirmAction={message.confirmAction ? message.confirmAction : null}
                onClose={message.action ? message.action : () => onShowMessage({})}
            />}
            {showLoading && <CustomLoading open={showLoading} />}
        </Grid>
    );
}